/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconStripe.vue?vue&type=template&id=fafa0c88&scoped=true"
import script from "./IconStripe.vue?vue&type=script&lang=js"
export * from "./IconStripe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa0c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fafa0c88')) {
      api.createRecord('fafa0c88', component.options)
    } else {
      api.reload('fafa0c88', component.options)
    }
    module.hot.accept("./IconStripe.vue?vue&type=template&id=fafa0c88&scoped=true", function () {
      api.rerender('fafa0c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconStripe.vue"
export default component.exports